<template>
  <div>
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="单据号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input placeholder="请输入单据号" v-model="queryParam.billNo"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="来源类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select placeholder="请选择来源类型" allow-clear v-model="queryParam.sourceType">
                  <a-select-option value="采购转固">采购转固</a-select-option>
                  <a-select-option value="领用转固">领用转固</a-select-option>
                  <a-select-option value="手工转固">手工转固</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select placeholder="请选择状态" allow-clear v-model="queryParam.status">
                  <a-select-option value="0">未审核</a-select-option>
                  <a-select-option value="1">已审核</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="单据日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-range-picker style="width:100%" format="YYYY-MM-DD" v-model="queryParam.dateRange" @change="onDateChange" />
              </a-form-item>
            </a-col>
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-col :md="6" :sm="24">
                <a-button type="primary" @click="searchQuery">查询</a-button>
                <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
              </a-col>
            </span>
          </a-row>
        </a-form>
      </div>
      <!-- 操作按钮区域 -->
      <div class="table-operator" style="margin-top: 5px">
        <a-button type="primary" icon="plus" v-if="btnEnableList.indexOf('1') > -1" @click="openAdd">新增</a-button>
        <a-button style="margin-left: 8px" icon="sync" @click="loadData">刷新</a-button>
        <a-button style="margin-left: 8px" icon="download" v-if="btnEnableList.indexOf('3') > -1" @click="exportExcel">导出</a-button>
      </div>
      <a-table bordered size="middle" rowKey="id" :columns="columns" :dataSource="tableData"
        :loading="loading" :pagination="false" :scroll="tableScroll">
        <span slot="billTime" slot-scope="text">{{ text ? text.substring(0, 10) : '' }}</span>
        <span slot="status" slot-scope="text">
          <a-tag :color="text === '1' ? 'green' : (text === '9' ? 'blue' : 'orange')">{{ statusText(text) }}</a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handlePrint(record)">打印</a>
          <a-divider type="vertical" />
          <template v-if="record.status === '0'">
            <a @click="openEdit(record)">编辑</a>
            <a-divider type="vertical" />
            <a v-if="canAudit(billPrefix(record.billNo))" @click="handleAudit(record)">审核</a>
            <a-divider v-if="canAudit(billPrefix(record.billNo))" type="vertical" />
            <a v-if="canSubmitFlow(billPrefix(record.billNo))" @click="handleSubmitFlow(record)">提交审批</a>
            <a-divider v-if="canSubmitFlow(billPrefix(record.billNo))" type="vertical" />
            <a-popconfirm title="作废并删除该单据?" @confirm="() => handleDelete(record)">
              <a style="color: red;">作废</a>
            </a-popconfirm>
          </template>
          <template v-else>
            <a @click="openDetail(record)">详情</a>
            <a-divider type="vertical" />
            <a @click="openVoucher(record)">凭证</a>
            <a-divider type="vertical" />
            <a @click="handleUnaudit(record)">反审核</a>
            <a-divider v-if="Number(record.lastDebt) > 0" type="vertical" />
            <a v-if="Number(record.lastDebt) > 0" @click="openPayment(record)">付款核销</a>
          </template>
        </span>
      </a-table>
      <a-pagination style="margin-top: 12px; text-align: right;" show-size-changer show-quick-jumper
        :current="ipagination.current" :page-size="ipagination.pageSize"
        :page-size-options="ipagination.pageSizeOptions" :total="ipagination.total"
        @change="handleTableChange" @showSizeChange="handleTableChange" />
    </a-card>

    <!-- 新增/编辑 -->
    <a-modal :title="form.id ? '编辑转固单' : '新增转固单'" :width="1080" :visible="visible"
      :maskClosable="false" @cancel="visible = false">
      <a-form layout="vertical">
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-item label="来源类型（必选）">
              <a-select v-model="form.sourceType" placeholder="选择来源类型" style="width: 100%" :disabled="!!form.id" @change="onChangeSourceType">
                <a-select-option value="采购转固">采购转固</a-select-option>
                <a-select-option value="领用转固">领用转固</a-select-option>
                <a-select-option value="手工转固">手工转固</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col v-if="form.sourceType === '采购转固'" :span="6">
            <a-form-item label="供应商（必选）">
              <a-select v-model="form.organId" placeholder="选择供应商" show-search option-filter-prop="children" style="width: 100%">
                <a-select-option v-for="s in supList" :key="s.id" :value="s.id">{{ s.supplier }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col v-if="form.sourceType === '采购转固' || form.sourceType === '领用转固'" :span="6">
            <a-form-item label="来源单据">
              <a-input-search v-model="form.sourceBillNo" readOnly placeholder="点击选择" style="width: 100%" @search="openSourceModal" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="单据日期（必填）">
              <j-date v-model="form.billTime" style="width: 100%" format="YYYY-MM-DD" />
            </a-form-item>
          </a-col>
        </a-row>

        <!-- 明细 -->
        <div style="margin-bottom: 8px;">
          <a-button v-if="form.sourceType === '手工转固'" icon="plus" size="small" @click="addItemRow">添加明细</a-button>
          <span style="margin-left: 12px; color: #999;">合计金额：{{ totalAmount }}</span>
        </div>
        <a-table bordered size="small" rowKey="_key" :columns="itemColumns" :dataSource="form.items" :pagination="false"
          :scroll="{ x: 'max-content', y: 240 }">
          <span slot="qty" slot-scope="text, record">
            <a-input-number :value="record.qty" :min="1" :precision="0" style="width: 100%"
              :disabled="form.sourceType !== '手工转固'" @change="(v) => onItemChange(record, 'qty', v)" />
          </span>
          <span slot="price" slot-scope="text, record">
            <a-input-number :value="record.price" :min="0" :precision="2" style="width: 100%"
              :disabled="form.sourceType !== '手工转固'" @change="(v) => onItemChange(record, 'price', v)" />
          </span>
          <span slot="remark" slot-scope="text, record">
            <a-input :value="record.remark" @change="(e) => onItemChange(record, 'remark', e.target.value)" />
          </span>
          <span slot="categoryId" slot-scope="text, record">
            <a-select :value="record.categoryId" placeholder="选择资产类别" show-search option-filter-prop="children" style="width: 100%"
              @change="(v) => onItemChange(record, 'categoryId', v)">
              <a-select-option v-for="c in categoryOptions" :key="c.id" :value="c.id">{{ c.name }}</a-select-option>
            </a-select>
          </span>
          <span slot="materialId" slot-scope="text, record">
            <a-select v-if="form.sourceType === '手工转固'" :value="record.materialId" placeholder="选择物资" show-search
              option-filter-prop="children" style="width: 100%" @change="(v) => onSelectMaterial(record, v)">
              <a-select-option v-for="m in materialOptions" :key="m.id" :value="m.id">{{ m.name }}{{ m.model ? ' / ' + m.model : '' }}</a-select-option>
            </a-select>
            <span v-else>{{ record.materialName }}{{ record.materialModel ? ' / ' + record.materialModel : '' }}</span>
          </span>
          <span slot="action" slot-scope="text, record">
            <a-popconfirm v-if="form.sourceType === '手工转固'" title="删除该行?" @confirm="() => removeItemRow(record)">
              <a style="color: red;">删除</a>
            </a-popconfirm>
          </span>
        </a-table>

        <!-- 结算信息 -->
        <a-row :gutter="16" style="margin-top: 12px;" v-if="form.sourceType === '采购转固'">
          <a-col :span="6"><a-form-item label="优惠金额"><a-input-number v-model="form.discountMoney" :min="0" :precision="2" style="width: 100%" @change="calcDebt" /></a-form-item></a-col>
          <a-col :span="6"><a-form-item label="优惠后金额"><a-input :value="discountLastMoney" readOnly /></a-form-item></a-col>
          <a-col :span="6"><a-form-item label="其它费用"><a-input-number v-model="form.otherMoney" :min="0" :precision="2" style="width: 100%" @change="calcDebt" /></a-form-item></a-col>
          <a-col :span="6"><a-form-item label="支付订金"><a-input-number v-model="form.deposit" :min="0" :precision="2" style="width: 100%" @change="calcDebt" /></a-form-item></a-col>
        </a-row>
        <a-row :gutter="16" v-if="form.sourceType === '采购转固'">
          <a-col :span="8">
            <a-form-item label="结算账户">
              <a-select v-model="form.accountId" placeholder="请选择结算账户" allow-clear style="width: 70%" @change="onSingleAccountChange">
                <a-select-option v-for="a in accountList" :key="a.id" :value="a.id">{{ a.name }}</a-select-option>
              </a-select>
              <a-button size="small" style="margin-left: 8px" @click="openFormManyAccount">多账户</a-button>
            </a-form-item>
          </a-col>
          <a-col :span="8" v-if="!manyAccountStatus">
            <a-form-item label="本次支付金额"><a-input-number v-model="form.payMoney" :min="0" :precision="2" style="width: 100%" @change="calcDebt" /></a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="本次欠款"><a-input :value="debtValue" readOnly /></a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16" v-if="form.sourceType === '手工转固'">
          <a-col :span="6"><a-form-item label="借方科目编码（可选）"><a-input v-model="form.debitCode" placeholder="如 1601，留空走规则" /></a-form-item></a-col>
          <a-col :span="6"><a-form-item label="贷方科目编码（可选）"><a-input v-model="form.creditCode" placeholder="如 1002，留空走规则" /></a-form-item></a-col>
        </a-row>
        <a-form-item label="备注"><a-input v-model="form.remark" /></a-form-item>
      </a-form>
      <template slot="footer">
        <a-button @click="visible = false">取消</a-button>
        <a-button v-if="!multiOn(modalPrefix())" :loading="saving" @click="handleSave">保存</a-button>
        <a-button v-if="!multiOn(modalPrefix()) || !flowOn(modalPrefix())" :loading="saving" @click="handleSaveAndCheck">保存并审核</a-button>
        <a-button v-if="multiOn(modalPrefix()) && flowOn(modalPrefix())" :loading="saving" @click="handleSaveAndFlow">保存并提交流程</a-button>
      </template>
    </a-modal>

    <!-- 来源单选择 -->
    <a-modal :title="form.sourceType === '采购转固' ? '选择采购订单' : '选择资产出库单'" :width="760" :visible="sourceVisible"
      :footer="null" @cancel="sourceVisible = false">
      <a-table bordered size="small" rowKey="id" :columns="sourceColumns" :dataSource="sourceRows"
        :loading="sourceLoading" :pagination="sourcePagination" :rowSelection="{ type: 'radio', selectedRowKeys: sourceSelected, onChange: onSourceSelect }"
        :scroll="{ x: 'max-content' }" @change="onSourcePageChange">
      </a-table>
      <div style="margin-top: 12px; text-align: right;">
        <a-button style="margin-right: 8px" @click="sourceVisible = false">取消</a-button>
        <a-button type="primary" :disabled="sourceSelected.length === 0" @click="confirmSource">加载明细</a-button>
      </div>
    </a-modal>

    <!-- 明细选择 -->
    <a-modal title="选择转固明细（已生成卡片的明细已自动排除）" :width="860" :visible="itemPickVisible"
      :confirmLoading="itemPickLoading" @ok="confirmItems" @cancel="itemPickVisible = false">
      <a-table bordered size="small" rowKey="id" :columns="itemPickColumns" :dataSource="itemPickRows"
        :pagination="false" :scroll="{ x: 'max-content', y: 300 }"
        :rowSelection="{ selectedRowKeys: itemPickSelected, onChange: (keys) => itemPickSelected = keys }" />
    </a-modal>

    <!-- 详情 -->
    <a-modal title="转固单详情" :width="900" :visible="detailVisible" :footer="null" @cancel="detailVisible = false">
      <a-descriptions bordered size="small" :column="2">
        <a-descriptions-item label="单据号">{{ detail.billNo }}</a-descriptions-item>
        <a-descriptions-item label="来源类型">{{ detail.sourceType }}</a-descriptions-item>
        <a-descriptions-item label="供应商">{{ detail.organName }}</a-descriptions-item>
        <a-descriptions-item label="来源单据">{{ detail.sourceBillNo }}</a-descriptions-item>
        <a-descriptions-item label="单据日期">{{ detail.billTime }}</a-descriptions-item>
        <a-descriptions-item label="合计金额">{{ detail.totalAmount }}</a-descriptions-item>
        <a-descriptions-item label="优惠后金额">{{ detail.discountLastMoney }}</a-descriptions-item>
        <a-descriptions-item label="其它费用">{{ detail.otherMoney }}</a-descriptions-item>
        <a-descriptions-item label="支付订金">{{ detail.deposit }}</a-descriptions-item>
        <a-descriptions-item label="欠款">{{ detail.debt }}</a-descriptions-item>
        <a-descriptions-item label="剩余欠款">{{ detail.lastDebt }}</a-descriptions-item>
        <a-descriptions-item label="状态">{{ statusText(detail.status) }}</a-descriptions-item>
        <a-descriptions-item label="借方科目">{{ detail.debitSubjectText || '-' }}</a-descriptions-item>
        <a-descriptions-item label="贷方科目">{{ detail.creditSubjectText || '-' }}</a-descriptions-item>
        <a-descriptions-item label="备注" :span="2">{{ detail.remark }}</a-descriptions-item>
      </a-descriptions>
      <a-table v-if="detailItems.length" bordered size="small" rowKey="id" style="margin-top: 12px;"
        :columns="detailItemColumns" :dataSource="detailItems" :pagination="false" :scroll="{ x: 'max-content' }" />
    </a-modal>

    <many-account-modal ref="manyAccountModalForm" @ok="manyAccountOk" />
    <asset-bill-print ref="assetPrint" />

    <!-- 关联凭证查看 -->
    <a-modal title="关联凭证" :width="860" :visible="voucherVisible" :footer="null" @cancel="voucherVisible = false">
      <div v-for="v in voucherRows" :key="v.id" style="margin-bottom: 16px;">
        <div style="margin-bottom: 4px; color: #666;">
          凭证字号：{{ v.voucherNo }}　日期：{{ fmtVoucherDate(v.voucherDate) }}　业务：{{ v.bizNode }}　
          状态：{{ v.status === '1' ? '已审核' : '未审核' }}
        </div>
        <a-table bordered size="small" rowKey="id" :columns="voucherItemColumns" :dataSource="v.items || []"
          :pagination="false" :scroll="{ x: 'max-content' }" />
      </div>
      <a-empty v-if="!voucherRows.length" description="暂无凭证" />
    </a-modal>
  </div>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import ApprovalButtonMixin from './mixins/ApprovalButtonMixin'
import { transferList, transferGet, transferSave, transferDelete, transferAudit, transferUnaudit, transferPayment,
  transferPurchaseOrders, transferInnerOuts, transferSourceItems, transferVouchers, categoryList, materialList } from './api/fixedAsset'
import { findBySelectSup, getAccount } from '@/api/api'
import { getNowFormatDateTime } from '@/utils/util'
import moment from 'moment'
import ManyAccountModal from '../../bill/dialog/ManyAccountModal'
import AssetBillPrint from './AssetBillPrint.vue'

let itemKeySeq = 1

export default {
  name: 'AssetTransferList',
  mixins: [JeecgListMixin, ApprovalButtonMixin],
  components: { ManyAccountModal, AssetBillPrint },
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 18, offset: 1 },
      urlPath: '/plugin/fixed-asset/transfer',
      prefixNo: 'ZG',
      loading: false,
      saving: false,
      visible: false,
      detailVisible: false,
      detail: {},
      detailItems: [],
      form: {},
      tableData: [],
      supList: [],
      categoryOptions: [],
      materialOptions: [],
      accountList: [],
      manyAccountStatus: false,
      sourceVisible: false,
      sourceLoading: false,
      sourceRows: [],
      sourceSelected: [],
      sourcePagination: { current: 1, pageSize: 10, total: 0 },
      itemPickVisible: false,
      itemPickLoading: false,
      itemPickRows: [],
      itemPickSelected: [],
      voucherVisible: false,
      voucherRows: [],
      payRecord: {},
      tableScroll: { x: 'max-content', y: 400 },
      queryParam: {},
      ipagination: { current: 1, pageSize: 10, pageSizeOptions: ['10', '20', '50'], total: 0 },
      columns: [
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 300 },
        { title: '单据号', dataIndex: 'billNo', width: 150 },
        { title: '来源类型', dataIndex: 'sourceType', width: 100 },
        { title: '供应商', dataIndex: 'organName', width: 150 },
        { title: '来源单据', dataIndex: 'sourceBillNo', width: 140 },
        { title: '合计金额', dataIndex: 'totalAmount', width: 110 },
        { title: '剩余欠款', dataIndex: 'lastDebt', width: 110 },
        { title: '状态', dataIndex: 'status', width: 90, scopedSlots: { customRender: 'status' } },
        { title: '单据日期', dataIndex: 'billTime', width: 110, scopedSlots: { customRender: 'billTime' } }
      ],
      itemColumns: [
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 60 },
        { title: '物资', dataIndex: 'materialId', scopedSlots: { customRender: 'materialId' }, width: 200 },
        { title: '资产类别（必选）', dataIndex: 'categoryId', scopedSlots: { customRender: 'categoryId' }, width: 180 },
        { title: '数量', dataIndex: 'qty', scopedSlots: { customRender: 'qty' }, width: 100 },
        { title: '单价', dataIndex: 'price', scopedSlots: { customRender: 'price' }, width: 110 },
        { title: '金额', dataIndex: 'amount', width: 110 },
        { title: '备注', dataIndex: 'remark', scopedSlots: { customRender: 'remark' } }
      ],
      sourceColumns: [
        { title: '单据编号', dataIndex: 'number', width: 160 },
        { title: '单据日期', dataIndex: 'operTime', width: 160, customRender: (t) => (t || '').substring(0, 10) },
        { title: '金额', dataIndex: 'totalPrice', width: 110 }
      ],
      itemPickColumns: [
        { title: '物资', dataIndex: 'materialName', width: 180, customRender: (t, r) => t + (r.materialModel ? ' / ' + r.materialModel : '') },
        { title: '数量', dataIndex: 'qty', width: 90 },
        { title: '单价', dataIndex: 'price', width: 100 },
        { title: '金额', dataIndex: 'amount', width: 110 }
      ],
      detailItemColumns: [
        { title: '物资', dataIndex: 'materialName', width: 180, customRender: (t, r) => t + (r.materialModel ? ' / ' + r.materialModel : '') },
        { title: '资产类别', dataIndex: 'categoryName', width: 140 },
        { title: '数量', dataIndex: 'qty', width: 80 },
        { title: '单价', dataIndex: 'price', width: 100 },
        { title: '金额', dataIndex: 'amount', width: 110 },
        { title: '已生成卡片', dataIndex: 'cardFlag', width: 100, customRender: (t) => (t === '1' ? '是' : '否') },
        { title: '备注', dataIndex: 'remark' }
      ],
      voucherItemColumns: [
        { title: '摘要', dataIndex: 'summary', width: 240 },
        { title: '科目', dataIndex: 'subjectCode', width: 240, customRender: (t, r) => (t ? t + '_' + (r.subjectName || '') : '') },
        { title: '借方金额', dataIndex: 'debitAmount', width: 110, align: 'right' },
        { title: '贷方金额', dataIndex: 'creditAmount', width: 110, align: 'right' }
      ]
    }
  },
  computed: {
    totalAmount() {
      return (this.form.items || []).reduce((s, it) => s + (Number(it.amount) || 0), 0).toFixed(2)
    },
    discountLastMoney() {
      return (Number(this.totalAmount) - (Number(this.form.discountMoney) || 0)).toFixed(2)
    },
    debtValue() {
      const paid = this.manyAccountStatus ? this.manyAccountPaid : (Number(this.form.payMoney) || 0)
      const v = Number(this.discountLastMoney) + (Number(this.form.otherMoney) || 0) - (Number(this.form.deposit) || 0) - paid
      return v.toFixed(2)
    },
    manyAccountPaid() {
      return (this.form.accountMoneyList || '').split(',').filter(Boolean).reduce((s, m) => s + Math.abs(Number(m) || 0), 0).toFixed(2)
    }
  },
  mounted() {
    this.$nextTick(() => { this.tableScroll.y = Math.max(300, window.innerHeight - 360) })
  },
  created() {
    this.loadData()
    this.loadOptions()
    this.loadApprovalState()
  },
  methods: {
    statusText(s) { return s === '1' ? '已审核' : (s === '9' ? '审批中' : '未审核') },
    loadData() {
      this.loading = true
      transferList({
        page: this.ipagination.current, pageSize: this.ipagination.pageSize,
        billNo: this.queryParam.billNo || null, sourceType: this.queryParam.sourceType || null,
        status: this.queryParam.status || null,
        beginTime: this.queryParam.beginTime || null, endTime: this.queryParam.endTime || null
      }).then((res) => {
        this.loading = false
        if (res && res.success) {
          this.tableData = (res.data && res.data.records) || []
          this.ipagination.total = res.data.total || 0
        } else {
          this.$message.error((res && res.message) || '查询失败')
        }
      }).catch(() => { this.loading = false })
    },
    loadOptions() {
      findBySelectSup({}).then((res) => { if (res) this.supList = res })
      getAccount({}).then((res) => { if (res && res.code === 200) this.accountList = res.data.accountList || [] })
      categoryList().then((res) => { if (res && res.success) this.categoryOptions = res.data || [] })
      materialList({ page: 1, pageSize: 500, enableAsset: '1' }).then((res) => {
        if (res && res.success) this.materialOptions = (res.data && res.data.records) || []
      })
    },
    onDateChange(dateString) {
      if (dateString && dateString.length === 2) {
        this.queryParam.beginTime = dateString[0]
        this.queryParam.endTime = dateString[1]
      } else {
        this.queryParam.beginTime = ''
        this.queryParam.endTime = ''
      }
    },
    searchQuery() { this.ipagination.current = 1; this.loadData() },
    searchReset() { this.queryParam = {}; this.ipagination.current = 1; this.loadData() },
    handleTableChange(page, pageSize) { this.ipagination.current = page; this.ipagination.pageSize = pageSize; this.loadData() },
    // ==================== 新增/编辑 ====================
    openAdd() {
      this.form = { sourceType: undefined, items: [], billTime: getNowFormatDateTime().substring(0, 10) }
      this.manyAccountStatus = false
      this.visible = true
    },
    openEdit(r) {
      transferGet(r.id).then((res) => {
        if (res && res.success) {
          const head = res.data.head || {}
          const items = (res.data.items || []).map((it) => ({ ...it, _key: 'k' + (itemKeySeq++) }))
          this.manyAccountStatus = !!head.accountIdList && head.accountIdList.indexOf(',') > -1
          const ids = (head.accountIdList || '').split(',').filter(Boolean)
          const monies = (head.accountMoneyList || '').split(',').filter(Boolean)
          const singlePaid = this.manyAccountStatus ? 0 : this.paidFromHead(head)
          this.form = {
            id: head.id, sourceType: head.sourceType, organId: head.organId == null ? undefined : Number(head.organId),
            sourceBillId: head.sourceBillId, sourceBillNo: head.sourceBillNo,
            discountMoney: head.discountMoney == null ? undefined : Number(head.discountMoney),
            otherMoney: head.otherMoney == null ? undefined : Number(head.otherMoney),
            deposit: head.deposit == null ? undefined : Number(head.deposit),
            payMoney: (!this.manyAccountStatus && monies.length) ? Number(monies[0]) : (singlePaid || undefined),
            accountId: (!this.manyAccountStatus && ids.length) ? Number(ids[0]) : undefined,
            debitCode: head.debitCode, creditCode: head.creditCode,
            billTime: head.billTime ? head.billTime.substring(0, 10) : undefined, remark: head.remark,
            accountIdList: head.accountIdList, accountMoneyList: head.accountMoneyList, items
          }
          this.visible = true
        } else {
          this.$message.error((res && res.message) || '查询失败')
        }
      })
    },
    paidFromHead(head) {
      // 单账户历史支付额 = debt + 支付合计 - 优惠后 - 其它 + 订金（无独立字段，按 debt 公式反推）
      const dlm = Number(head.discountLastMoney) || 0
      const other = Number(head.otherMoney) || 0
      const dep = Number(head.deposit) || 0
      const debt = Number(head.debt) || 0
      return dlm + other - dep - debt
    },
    onChangeSourceType() {
      this.form.sourceBillId = undefined
      this.form.sourceBillNo = undefined
      this.form.items = []
    },
    addItemRow() {
      this.form.items.push({ _key: 'k' + (itemKeySeq++), materialId: undefined, materialName: '', categoryId: undefined, qty: 1, price: 0, amount: 0, remark: '' })
    },
    removeItemRow(record) {
      this.form.items = this.form.items.filter((it) => it._key !== record._key)
    },
    onSelectMaterial(record, v) {
      const m = this.materialOptions.find((x) => x.id === v)
      record.materialId = v
      record.materialName = m ? m.name : ''
      record.materialModel = m ? m.model : ''
    },
    onItemChange(record, col, v) {
      record[col] = v
      if (col === 'qty' || col === 'price') {
        record.amount = ((Number(record.qty) || 0) * (Number(record.price) || 0)).toFixed(2)
      }
      this.form.items = [...this.form.items]
    },
    calcDebt() { /* 计算属性自动联动，占位触发响应 */ },
    onSingleAccountChange() { this.manyAccountStatus = false; this.form.accountIdList = ''; this.form.accountMoneyList = '' },
    openFormManyAccount() {
      this.$refs.manyAccountModalForm.edit(this.form.accountIdList || '', this.form.accountMoneyList || '')
    },
    manyAccountOk(accountIdList, accountMoneyList) {
      // 付款核销回调（带 payRecord）或表单多账户回调
      if (this.payRecord && this.payRecord.id) {
        const p = { accountIdList: accountIdList.join(','), accountMoneyList: accountMoneyList.join(',') }
        transferPayment(this.payRecord.id, p).then((res) => {
          if (res && res.success) { this.$message.success('付款核销成功'); this.loadData() } else { this.$message.error((res && res.message) || '付款核销失败') }
        })
        this.payRecord = {}
        return
      }
      this.manyAccountStatus = accountIdList.length > 0
      this.form.accountIdList = accountIdList.join(',')
      this.form.accountMoneyList = accountMoneyList.join(',')
    },
    // ==================== 来源单选择 ====================
    openSourceModal() {
      this.sourceSelected = []
      this.sourcePagination.current = 1
      this.sourceVisible = true
      this.loadSourceRows()
    },
    loadSourceRows() {
      this.sourceLoading = true
      const api = this.form.sourceType === '采购转固' ? transferPurchaseOrders : transferInnerOuts
      api({ page: this.sourcePagination.current, pageSize: this.sourcePagination.pageSize }).then((res) => {
        this.sourceLoading = false
        if (res && res.success) {
          const data = res.data || {}
          this.sourceRows = data.records || data || []
          this.sourcePagination.total = data.total != null ? data.total : this.sourceRows.length
        } else {
          this.$message.error((res && res.message) || '查询失败')
        }
      }).catch(() => { this.sourceLoading = false })
    },
    onSourcePageChange(pag) {
      this.sourcePagination.current = pag.current
      this.sourcePagination.pageSize = pag.pageSize
      this.loadSourceRows()
    },
    onSourceSelect(keys, rows) { this.sourceSelected = keys },
    confirmSource() {
      const row = this.sourceRows.find((r) => r.id === this.sourceSelected[0])
      if (!row) return
      this.form.sourceBillId = row.id
      this.form.sourceBillNo = row.number
      if (this.form.sourceType === '采购转固' && row.organId && !this.form.organId) {
        this.form.organId = row.organId
      }
      this.sourceVisible = false
      this.itemPickVisible = true
      this.itemPickSelected = []
      this.itemPickLoading = true
      transferSourceItems(row.id).then((res) => {
        this.itemPickLoading = false
        if (res && res.success) {
          this.itemPickRows = res.data || []
          this.itemPickSelected = this.itemPickRows.map((r) => r.id)
        } else {
          this.itemPickVisible = false
          this.$message.error((res && res.message) || '查询明细失败')
        }
      }).catch(() => { this.itemPickLoading = false; this.itemPickVisible = false })
    },
    confirmItems() {
      const picked = this.itemPickRows.filter((r) => this.itemPickSelected.indexOf(r.id) > -1)
      this.form.items = picked.map((r) => ({
        _key: 'k' + (itemKeySeq++), sourceDetailId: r.id, materialId: r.materialId,
        materialName: r.materialName, materialModel: r.materialModel,
        categoryId: undefined, qty: Number(r.qty) || 1,
        price: Number(r.price) || 0, amount: Number(r.amount) || 0, remark: ''
      }))
      this.itemPickVisible = false
    },
    // ==================== 保存 ====================
    /** 校验并保存，成功 resolve {id, billNo}，校验失败返回 null */
    saveBill() {
      if (!this.form.sourceType) { this.$message.warning('请选择来源类型'); return null }
      if (this.form.sourceType === '采购转固' && !this.form.organId) { this.$message.warning('采购转固必须选择供应商'); return null }
      if (!this.form.items || this.form.items.length === 0) { this.$message.warning('转固明细不能为空'); return null }
      if (this.form.items.some((it) => !it.categoryId)) { this.$message.warning('每条明细必须选择资产类别'); return null }
      if (!this.form.billTime) { this.$message.warning('请选择单据日期'); return null }
      const debt = Number(this.form.sourceType === '采购转固' ? this.debtValue : 0) || 0
      // 单账户模式：账户id+支付金额一并落入 accountIdList/accountMoneyList，供凭证引擎取付款金额
      const singleAccountId = !this.manyAccountStatus && this.form.accountId && Number(this.form.payMoney) > 0 ? String(this.form.accountId) : ''
      const singleAccountMoney = singleAccountId !== '' ? String(Number(this.form.payMoney)) : ''
      const p = {
        id: this.form.id,
        sourceType: this.form.sourceType, organId: this.form.organId,
        sourceBillId: this.form.sourceBillId, sourceBillNo: this.form.sourceBillNo,
        discountMoney: this.form.discountMoney || 0, otherMoney: this.form.otherMoney || 0,
        deposit: this.form.deposit || 0,
        accountIdList: this.manyAccountStatus ? (this.form.accountIdList || '') : singleAccountId,
        accountMoneyList: this.manyAccountStatus ? (this.form.accountMoneyList || '') : singleAccountMoney,
        debitCode: this.form.debitCode, creditCode: this.form.creditCode,
        billTime: this.form.billTime.length > 10 ? this.form.billTime.substring(0, 10) : this.form.billTime,
        remark: this.form.remark,
        discountLastMoney: Number(this.form.sourceType === '采购转固' ? this.discountLastMoney : this.totalAmount) || 0,
        debt: debt, lastDebt: debt,
        items: this.form.items.map((it) => ({
          sourceDetailId: it.sourceDetailId, materialId: it.materialId, categoryId: it.categoryId,
          qty: it.qty, price: it.price, amount: it.amount, remark: it.remark
        }))
      }
      this.saving = true
      return transferSave(p).then((res) => {
        if (!(res && res.success)) {
          this.$message.error((res && res.message) || '保存失败')
          return Promise.reject(new Error('保存失败'))
        }
        const id = res.data
        return transferGet(id).then((g) => {
          return { id: id, billNo: (g && g.data && g.data.head && g.data.head.billNo) || '' }
        }).catch(() => { return { id: id, billNo: '' } })
      }, () => {
        this.$message.error('保存失败')
        return Promise.reject(new Error('保存失败'))
      }).then((r) => { this.saving = false; return r }, (e) => { this.saving = false; return Promise.reject(e) })
    },
    handleSave() {
      const task = this.saveBill()
      if (!task) return
      task.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.loadData()
      }).catch(() => {})
    },
    /** 保存并审核 */
    handleSaveAndCheck() {
      const task = this.saveBill()
      if (!task) return
      this.saving = true
      task.then((r) => transferAudit(r.id)).then((res) => {
        this.saving = false
        if (res && res.success) {
          this.$message.success('保存并审核成功')
          this.visible = false
          this.loadData()
        } else {
          this.$message.error((res && res.message) || '审核失败')
          this.loadData()
        }
      }).catch(() => { this.saving = false; this.loadData() })
    },
    /** 保存并提交流程 */
    handleSaveAndFlow() {
      const task = this.saveBill()
      if (!task) return
      this.saving = true
      task.then((r) => this.submitFlowById(4, r.billNo)).then((res) => {
        this.saving = false
        if (res && res.code === 200) {
          this.visible = false
          this.loadData()
        }
      }).catch(() => { this.saving = false; this.loadData() })
    },
    // ==================== 详情/审核/作废 ====================
    openDetail(r) {
      transferGet(r.id).then((res) => {
        if (res && res.success) {
          this.detail = res.data.head || {}
          this.detailItems = res.data.items || []
          this.detailVisible = true
          this.loadDetailSubjects(r.id)
        }
      })
    },
    /** 详情借贷科目：从关联凭证分录聚合（科目编码_科目名称） */
    loadDetailSubjects(id) {
      this.$set(this.detail, 'debitSubjectText', '')
      this.$set(this.detail, 'creditSubjectText', '')
      transferVouchers({ sourceType: 'asset_bill', sourceId: id, bizNode: '资产转固,资产核销' }).then((res) => {
        if (res && res.success) {
          const debits = []
          const credits = []
          ;(res.data || []).forEach((v) => (v.items || []).forEach((it) => {
            if (it.subjectCode && it.debitAmount != null) debits.push(it.subjectCode + '_' + it.subjectName)
            if (it.subjectCode && it.creditAmount != null) credits.push(it.subjectCode + '_' + it.subjectName)
          }))
          this.$set(this.detail, 'debitSubjectText', debits.length ? [...new Set(debits)].join('、') : '')
          this.$set(this.detail, 'creditSubjectText', credits.length ? [...new Set(credits)].join('、') : '')
        }
      })
    },
    /** 操作行"凭证"：查看该转固单生成的凭证（资产转固+资产核销） */
    openVoucher(r) {
      this.voucherRows = []
      this.voucherVisible = true
      transferVouchers({ sourceType: 'asset_bill', sourceId: r.id, bizNode: '资产转固,资产核销' }).then((res) => {
        if (res && res.success) {
          this.voucherRows = res.data || []
        } else {
          this.$message.error((res && res.message) || '查询凭证失败')
        }
      })
    },
    fmtVoucherDate(v) { return v ? moment(String(v)).format('YYYY-MM-DD') : '' },
    handleDelete(r) {
      transferDelete(r.id).then((res) => {
        if (res && res.success) { this.$message.success('作废成功'); this.loadData() } else { this.$message.error((res && res.message) || '作废失败') }
      })
    },
    handleAudit(r) {
      transferAudit(r.id).then((res) => {
        if (res && res.success) { this.$message.success('审核成功'); this.loadData() } else { this.$message.error((res && res.message) || '审核失败') }
      })
    },
    handleUnaudit(r) {
      transferUnaudit(r.id).then((res) => {
        if (res && res.success) { this.$message.success('反审核成功'); this.loadData() } else { this.$message.error((res && res.message) || '反审核失败') }
      })
    },
    /** 提交审批（workflow bigType=4 转固单） */
    handleSubmitFlow(r) {
      this.$confirm({
        title: '提交审批', content: `确认提交转固单 ${r.billNo} 至审批流程？`,
        onOk: () => this.submitFlowById(4, r.billNo).then((res) => {
          if (res && res.code === 200) this.loadData()
        })
      })
    },
    /** 付款核销（复用多账户弹窗：借应付/贷资金账户） */
    openPayment(r) {
      this.payRecord = r
      this.$refs.manyAccountModalForm.edit('', '')
    },
    /** 打印转固单（head+items 传入打印组件） */
    handlePrint(r) {
      transferGet(r.id).then((res) => {
        if (res && res.success) {
          this.$refs.assetPrint.show(r.billNo, '资产转固单', res.data.head || {}, res.data.items || [])
        }
      })
    },
    exportExcel() {
      const list = this.tableData.map((r) => [
        r.billNo || '', r.sourceType || '', r.organName || '', r.sourceBillNo || '',
        r.totalAmount == null ? '' : r.totalAmount, r.lastDebt == null ? '' : r.lastDebt,
        this.statusText(r.status), (r.billTime || '').substring(0, 10)
      ])
      this.handleExportXlsPost('资产转固单', '资产转固单', '单据号,来源类型,供应商,来源单据,合计金额,剩余欠款,状态,单据日期', '', list)
    }
  }
}
</script>
